import { colors } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";

import { ConfigureDestinationsModal } from "../../modals/ConfigureDestinationsModal";

import { DestinationConfigRow } from "../shared/ConfigPageRow";

const ConnectionModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const { settings: allSettings } = existingConfig;

  const limitSettings = [
    "apiKey",
    "appIdentifier",
    "version",
    "customEndpoint",
    "safariWebsitePushId",
    "doNotLoadFontAwesome",
  ];

  return (
    <ConfigureDestinationsModal
      limitSettings={limitSettings}
      open={open}
      includeHeader={true}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const ConnectionRow = ({ setConfigModalOpen, existingConfig }) => {
  const config = existingConfig.settings;
  const idSet = !!config.apiKey;

  return (
    <DestinationConfigRow
      name="Connection details"
      textColor={idSet ? "" : colors.red[600]}
      labelText={idSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("Connection")}
    />
  );
};

const InAppMessagesModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const { settings: allSettings } = existingConfig;

  const limitSettings = [
    "automaticallyDisplayMessages",
    "requireExplicitInAppMessageDismissal",
  ];

  if (allSettings.version !== "1") {
    // Only for v2+
    limitSettings.push("openInAppMessagesInNewTab");
    limitSettings.push("openNewsFeedCardsInNewTab");
    limitSettings.push("enableHtmlInAppMessages");
  }

  return (
    <ConfigureDestinationsModal
      limitSettings={limitSettings}
      open={open}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const InAppMessagesRow = ({ setConfigModalOpen, existingConfig }) => {
  const config = existingConfig.settings;
  const enabled = !!config.apiKey;

  return (
    <DestinationConfigRow
      disabled={!enabled}
      name="In-App Messages"
      labelText=""
      onOpenConfigModal={() => {
        if (enabled) {
          setConfigModalOpen();
        }
      }}
    />
  );
};

const DebugModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const allSettings = existingConfig.settings;

  return (
    <ConfigureDestinationsModal
      limitSettings={["enableLogging"]}
      open={open}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      title="Event tracking"
      existingConfig={existingConfig}
    />
  );
};

const DebugRow = ({ setConfigModalOpen, existingConfig }) => {
  const config = existingConfig.settings;
  const enabled = !!config.apiKey && config.version !== "1";
  const title = "Debugging" + (config.version === "1" ? " (V2+ only)" : "");

  return (
    <DestinationConfigRow
      disabled={!enabled}
      name={title}
      labelText=""
      onOpenConfigModal={() => {
        if (enabled) {
          setConfigModalOpen();
        }
      }}
    />
  );
};

const CONNECTION = "CONNECTION";
const IN_APP_MESSAGES = "IN_APP_MESSAGES";
const DEBUG = "DEBUG";

const Rows = {
  CONNECTION: ConnectionRow,
  IN_APP_MESSAGES: InAppMessagesRow,
  DEBUG: DebugRow,
};

const Modals = {
  CONNECTION: ConnectionModal,
  IN_APP_MESSAGES: InAppMessagesModal,
  DEBUG: DebugModal,
};

const RowOrder = [CONNECTION, IN_APP_MESSAGES, DEBUG];

export default {
  Rows,
  RowOrder,
  Modals,
};
